// import React from 'react';

// const MissionVision = () => {
//   const primaryColor = "rgb(0, 111, 47)";

//   const sectionStyle = {
//     padding: "60px 20px",
//     maxWidth: "1100px",
//     margin: "0 auto",
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//     lineHeight: "1.6",
//     color: "#333"
//   };

//   const cardStyle = {
//     background: "#fff",
//     padding: "40px",
//     borderRadius: "15px",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
//     marginBottom: "40px",
//     borderLeft: `6px solid ${primaryColor}`
//   };

//   const headingStyle = {
//     color: primaryColor,
//     fontSize: "2.5rem",
//     textAlign: "center",
//     marginBottom: "40px",
//     fontWeight: "700"
//   };

//   const subHeadingStyle = {
//     color: primaryColor,
//     fontSize: "1.8rem",
//     marginBottom: "20px",
//     display: "flex",
//     alignItems: "center",
//     gap: "10px"
//   };

//   return (
//     <div style={{ paddingTop: "140px", backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
//       <div style={sectionStyle}>
        
//         {/* Main Title */}
//         <h1 style={headingStyle}>"Inspired to Educate. Committed to Enlighten."</h1>

//         {/* 1. OUR MISSION SECTION */}
//         <div style={cardStyle}>
//           <h2 style={subHeadingStyle}><span>🎯</span> Our Mission</h2>
//           <p><strong>The prime line of Delhi Public School is "Service Before Self."</strong></p>
//           <p>Our mission at DPS Kids Ladwa is to provide an exuberant learning forum guided by three powerful words: <strong>Inspire. Educate. Enlighten.</strong></p>
          
//           <h4 style={{marginTop: "20px"}}>We believe:</h4>
//           <ul style={{ paddingLeft: "20px" }}>
//             <li>Every child is unique, creative, and capable of greatness.</li>
//             <li>All children deserve access to high-quality, joyful education.</li>
//             <li>Learning must connect the classroom to the real world.</li>
//           </ul>

//           <h4 style={{marginTop: "20px"}}>To fulfil this mission, we commit to:</h4>
//           <ul style={{ paddingLeft: "20px" }}>
//             <li><strong>Differentiated learning programs</strong> — in-depth, cohesive, and aligned to CBSE standards.</li>
//             <li><strong>Highly effective teachers</strong> — focused on student outcomes through professional development and coaching.</li>
//             <li><strong>Social values and patriotism</strong> — nurturing every child to be a responsible, multi-talented individual.</li>
//           </ul>
//         </div>

//         {/* 2. OUR VISION SECTION */}
//         <div style={{...cardStyle, borderLeft: `6px solid #FFD700`}}> {/* Gold border for Vision */}
//           <h2 style={{...subHeadingStyle, color: "#b8860b"}}><span>👁️</span> Our Vision</h2>
//           <p>Delhi Public Schools provide a stage that is beautiful, true, and meaningful — a space where children move ahead in life with purpose.</p>
          
//           <h4 style={{marginTop: "20px"}}>We envision schools as places where:</h4>
//           <ul style={{ paddingLeft: "20px" }}>
//             <li>Intellectual, social, emotional, and spiritual development is fostered to enhance quality of life.</li>
//             <li>Student achievement is acknowledged and celebrated within the community.</li>
//             <li>Students are prepared for active, independent learning in an environment of healthy competition.</li>
//             <li>Every child's environment is their teacher — built on unquestioning trust.</li>
//           </ul>
//         </div>

//         {/* 3. WORLD OF ITS OWN SECTION */}
//         <div style={{
//           textAlign: "center", 
//           background: primaryColor, 
//           color: "#fff", 
//           padding: "50px", 
//           borderRadius: "15px",
//           marginTop: "60px"
//         }}>
//           <h2 style={{fontSize: "2rem", marginBottom: "15px"}}>DPS Kids — A World of Its Own</h2>
//           <p style={{fontStyle: "italic", fontSize: "1.2rem"}}>
//             "Others call it a Fun-School. We call it DPS Kids — a KID's Heaven."
//           </p>
//           <p style={{marginTop: "20px", maxWidth: "800px", margin: "20px auto"}}>
//             Catering to children aged 1.5 to 5.5 years, DPS Kids blends the finest of Montessori Play-way and Gurukul methods of education.
//           </p>
          
//           <div style={{
//             display: "grid", 
//             gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", 
//             gap: "20px", 
//             marginTop: "30px"
//           }}>
//             <div style={{background: "rgba(255,255,255,0.1)", padding: "15px", borderRadius: "10px"}}>Independence</div>
//             <div style={{background: "rgba(255,255,255,0.1)", padding: "15px", borderRadius: "10px"}}>Motor Skills</div>
//             <div style={{background: "rgba(255,255,255,0.1)", padding: "15px", borderRadius: "10px"}}>Verbal Communication</div>
//             <div style={{background: "rgba(255,255,255,0.1)", padding: "15px", borderRadius: "10px"}}>Social Awareness</div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default MissionVision;

// import React from 'react';

// const MissionVision = () => {
//   const primaryColor = "rgb(0, 111, 47)";

//   return (
//     <div style={{ backgroundColor: "#fcfcfc", minHeight: "100vh", fontFamily: "'Segoe UI', sans-serif" }}>
      
//       {/* 🖼️ HERO SECTION (Matching other pages) */}
//       <div style={styles.bannerHero}>
//         <img
//           src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1920&q=85"
//           alt="Mission Vision Banner"
//           style={styles.bannerImage}
//         />
//         <div style={styles.bannerOverlay} />
//         <div style={styles.bannerContent}>
//           <div style={styles.bannerBadge}>✨ OUR PURPOSE</div>
//           <h1 style={styles.bannerTitle}>Mission & Vision</h1>
//           <p style={styles.bannerSubtitle}>"Inspired to Educate. Committed to Enlighten."</p>
//         </div>
//       </div>

//       <div style={styles.section}>
        
//         {/* 🎯 1. OUR MISSION SECTION */}
//         <div style={{ ...styles.card, borderLeft: `6px solid ${primaryColor}` }}>
//           <div style={styles.cardHeader}>
//             <span style={styles.cardIcon}>🎯</span>
//             <h2 style={{ ...styles.subHeading, color: primaryColor }}>Our Mission</h2>
//           </div>
          
//           <p style={styles.mainPara}><strong>The prime line of Delhi Public School is "Service Before Self."</strong></p>
//           <p style={styles.descPara}>Our mission at DPS Kids Ladwa is to provide an exuberant learning forum guided by three powerful words: <strong>Inspire. Educate. Enlighten.</strong></p>
          
//           <h4 style={styles.listLabel}>We believe:</h4>
//           <ul style={styles.listContainer}>
//             {["Every child is unique, creative, and capable of greatness.", 
//               "All children deserve access to high-quality, joyful education.", 
//               "Learning must connect the classroom to the real world."].map((item, i) => (
//               <li key={i} className="mission-item" style={styles.listItem}>
//                 <span style={{ color: primaryColor, marginRight: "12px" }}>✓</span> {item}
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* 👁️ 2. OUR VISION SECTION */}
//         <div style={{ ...styles.card, borderLeft: `6px solid #FFD700` }}>
//           <div style={styles.cardHeader}>
//             <span style={styles.cardIcon}>👁️</span>
//             <h2 style={{ ...styles.subHeading, color: "#b8860b" }}>Our Vision</h2>
//           </div>
          
//           <p style={styles.descPara}>Delhi Public Schools provide a stage that is beautiful, true, and meaningful — a space where children move ahead in life with purpose.</p>
          
//           <h4 style={styles.listLabel}>We envision schools as places where:</h4>
//           <ul style={styles.listContainer}>
//             {["Intellectual, social, emotional, and spiritual development is fostered.", 
//               "Student achievement is acknowledged and celebrated.", 
//               "Students are prepared for active, independent learning.", 
//               "Every child's environment is their teacher — built on trust."].map((item, i) => (
//               <li key={i} className="mission-item" style={styles.listItem}>
//                 <span style={{ color: "#FFD700", marginRight: "12px" }}>★</span> {item}
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* 🌍 3. WORLD OF ITS OWN SECTION */}
//         <div style={{ ...styles.footerSection, background: primaryColor }}>
//           <h2 style={{ fontSize: "2.2rem", marginBottom: "15px" }}>DPS Kids — A World of Its Own</h2>
//           <p style={{ fontStyle: "italic", fontSize: "1.2rem", opacity: 0.9 }}>
//             "Others call it a Fun-School. We call it DPS Kids — a KID's Heaven."
//           </p>
          
//           <div style={styles.gridContainer}>
//             {["Independence", "Motor Skills", "Communication", "Social Awareness"].map((text, i) => (
//               <div key={i} className="grid-box" style={styles.gridBox}>{text}</div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* 🔮 CSS ANIMATIONS (Floating List Items) */}
//       <style>{`
//         .mission-item {
//           transition: all 0.3s ease;
//           cursor: pointer;
//         }
//         .mission-item:hover {
//           transform: translateX(10px);
//           color: ${primaryColor};
//           font-weight: 600;
//         }
//         .grid-box {
//           transition: 0.3s;
//         }
//         .grid-box:hover {
//           background: #fff !important;
//           color: ${primaryColor} !important;
//           transform: translateY(-5px);
//         }
//       `}</style>
//     </div>
//   );
// };

// const styles = {
//   bannerHero: { position: "relative", width: "100%", height: "400px", overflow: "hidden" },
//   bannerImage: { width: "100%", height: "100%", objectFit: "cover" },
//   bannerOverlay: { position: "absolute", inset: 0, background: "linear-gradient(rgba(0,111,47,0.7), rgba(0,0,0,0.7))" },
//   bannerContent: { position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#fff", textAlign: "center" },
//   bannerBadge: { background: "#FFD700", color: "#000", padding: "6px 18px", borderRadius: "50px", fontWeight: "bold", marginBottom: "15px", fontSize: "0.9rem" },
//   bannerTitle: { fontSize: "3.5rem", fontWeight: "900", margin: 0 },
//   bannerSubtitle: { fontSize: "1.3rem", opacity: 0.9, marginTop: "10px" },

//   section: { maxWidth: "1100px", margin: "0 auto", padding: "60px 20px" },
//   card: { background: "#fff", padding: "40px", borderRadius: "20px", boxShadow: "0 10px 30px rgba(0,0,0,0.05)", marginBottom: "50px", display: "flex", flexDirection: "column", alignItems: "flex-start" },
//   cardHeader: { display: "flex", alignItems: "center", gap: "15px", marginBottom: "20px" },
//   cardIcon: { fontSize: "2.2rem" },
//   subHeading: { fontSize: "2rem", fontWeight: "700", margin: 0 },
  
//   mainPara: { fontSize: "1.2rem", color: "#222", marginBottom: "10px" },
//   descPara: { fontSize: "1.1rem", color: "#555", marginBottom: "25px", lineHeight: "1.7" },
  
//   listLabel: { fontSize: "1.1rem", fontWeight: "700", marginBottom: "15px", color: "#333" },
//   listContainer: { listStyle: "none", padding: 0, margin: 0, width: "100%" },
//   listItem: { padding: "12px 0", borderBottom: "1px solid #f0f0f0", display: "flex", alignItems: "center", fontSize: "1.05rem" },

//   footerSection: { textAlign: "center", color: "#fff", padding: "60px 40px", borderRadius: "30px", marginTop: "40px" },
//   gridContainer: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "20px", marginTop: "40px" },
//   gridBox: { background: "rgba(255,255,255,0.15)", padding: "20px", borderRadius: "15px", border: "1px solid rgba(255,255,255,0.3)", fontWeight: "600" }
// };

// export default MissionVision;

// import React from "react";

// const MissionVision = () => {
//   const primary = "rgb(0, 111, 47)";

//   return (
//     <div style={styles.container}>
      
//       {/* HERO */}
//       <div style={styles.hero}>
//         <img
//           src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655"
//           style={styles.heroImg}
//         />
//         <div style={styles.heroOverlay}>
//           <h1 style={styles.heroTitle}>Mission & Vision</h1>
//           <p style={styles.heroSub}>Inspire • Educate • Enlighten</p>
//         </div>
//       </div>

//       {/* ================= MISSION ================= */}
//       <div style={styles.section}>
//         <div style={styles.row}>

//           {/* LEFT IMAGE */}
//           <div style={styles.imageBox}>
//             <img
//               src="https://images.unsplash.com/photo-1588072432836-e10032774350"
//               style={styles.image}
//             />
//           </div>

//           {/* RIGHT CONTENT */}
//           <div style={styles.contentCard}>
//             <h2 style={{ color: primary }}>🎯 Our Mission</h2>

//             <p style={styles.text}>
//               <strong>Service Before Self</strong> is our foundation.
//               We inspire, educate and enlighten students to achieve excellence.
//             </p>

//             <ul style={styles.list}>
//               <li>Every child is unique & creative</li>
//               <li>Joyful and high-quality learning</li>
//               <li>Real-world connection in education</li>
//             </ul>
//           </div>

//         </div>
//       </div>

//       {/* ================= VISION ================= */}
//       <div style={styles.section}>
//         <div style={{ ...styles.row, flexDirection: "row-reverse" }}>

//           {/* RIGHT IMAGE */}
//           <div style={styles.imageBox}>
//             <img
//               src="https://images.unsplash.com/photo-1509062522246-3755977927d7"
//               style={styles.image}
//             />
//           </div>

//           {/* LEFT CONTENT */}
//           <div style={styles.contentCard}>
//             <h2 style={{ color: "#b8860b" }}>👁️ Our Vision</h2>

//             <p style={styles.text}>
//               We create a meaningful environment where students grow
//               intellectually, socially and emotionally with confidence.
//             </p>

//             <ul style={styles.list}>
//               <li>Holistic development</li>
//               <li>Celebrate student success</li>
//               <li>Independent thinkers</li>
//               <li>Trust-based environment</li>
//             </ul>
//           </div>

//         </div>
//       </div>

//       {/* FOOTER */}
//       <div style={styles.footer}>
//         <h2>DPS Kids — A World of Its Own</h2>
//         <p>Where learning meets happiness ✨</p>
//       </div>
//     </div>
//   );
// };

// /* ================= STYLES ================= */

// const styles = {
//   container: {
//     fontFamily: "Poppins, sans-serif",
//     background: "#f4f7f5",
//   },

//   hero: {
//     height: "380px",
//     position: "relative",
//   },
//   heroImg: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   heroOverlay: {
//     position: "absolute",
//     inset: 0,
//     background: "linear-gradient(rgba(0,111,47,0.6), rgba(0,0,0,0.7))",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     color: "#fff",
//   },
//   heroTitle: {
//     fontSize: "3.2rem",
//     fontWeight: "800",
//   },
//   heroSub: {
//     fontSize: "1.2rem",
//     opacity: 0.9,
//   },

//   section: {
//     padding: "80px 20px",
//   },

//   row: {
//     maxWidth: "1200px",
//     margin: "auto",
//     display: "flex",
//     alignItems: "center",
//     gap: "60px",
//     flexWrap: "wrap",
//   },

//   imageBox: {
//     flex: 1,
//     minWidth: "320px",
//   },

//   image: {
//     width: "100%",
//     height: "420px",
//     objectFit: "cover",
//     borderRadius: "25px",
//     boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
//   },

//   contentCard: {
//     flex: 1,
//     minWidth: "320px",
//     background: "#fff",
//     padding: "50px",
//     borderRadius: "25px",
//     boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
//   },

//   text: {
//     fontSize: "1.1rem",
//     color: "#555",
//     lineHeight: "1.7",
//     marginTop: "10px",
//   },

//   list: {
//     marginTop: "20px",
//     paddingLeft: "20px",
//     lineHeight: "2",
//   },

//   footer: {
//     textAlign: "center",
//     padding: "70px 20px",
//     background: "rgb(0, 111, 47)",
//     color: "#fff",
//   },
// };

// export default MissionVision;

// import React from "react";

// const MissionVision = () => {
//   const primaryColor = "rgb(0, 111, 47)";

//   return (
//     <div style={{ background: "#f8fafc", fontFamily: "sans-serif" }}>
      
//       {/* HERO */}
//       <div style={styles.hero}>
//         <img
//           src="https://dpsladwa.com/Dpsschool_Data/uploads/images/1776677437_69e5f23d6b57b.jpg"
//           style={styles.heroImg}
//         />
//         <div style={styles.overlay}></div>
//         <div style={styles.heroContent}>
//           <h1>Mission & Vision</h1>
//           <p>Inspired to Educate. Committed to Enlighten.</p>
//         </div>
//       </div>

//       <div style={styles.container}>

//         {/* 🔥 MISSION (Image Left, Content Right) */}
//         <div style={styles.row}>
//           <img
//             src="https://dpsladwa.com/Dpsschool_Data/uploads/images/1776677418_69e5f22a16a25.jpg"
//             style={styles.image}
//           />

//           <div style={styles.card}>
//             <h2 style={{ color: primaryColor }}> Our Mission</h2>
//             <p><b>"Service Before Self"</b></p>
//             <p>
//               Our mission is to create a joyful learning environment guided by:
//               <b> Inspire. Educate. Enlighten.</b>
//             </p>

//             <ul>
//               <li>✓ Every child is unique</li>
//               <li>✓ Quality education for all</li>
//               <li>✓ Real world learning</li>
//             </ul>
//           </div>
//         </div>

//         {/* 🔥 VISION (Content Left, Image Right) */}
//         <div style={{ ...styles.row, flexDirection: "row-reverse" }}>
//           <img
//             src="https://dpsladwa.com/Dpsschool_Data/uploads/images/1776677437_69e5f23d6b57b.jpg"
//             style={styles.image}
//           />

//           <div style={styles.card}>
//             <h2 style={{ color: "#b8860b" }}> Our Vision</h2>
//             <p>
//               We aim to create a meaningful space where students grow with purpose.
//             </p>

//             <ul>
//               <li>★ Holistic development</li>
//               <li>★ Celebrate achievements</li>
//               <li>★ Independent learners</li>
//               <li>★ Trust-based environment</li>
//             </ul>
//           </div>
//         </div>

//         {/* 🔥 FOOTER SECTION */}
//         <div style={styles.footer}>
//           <h2>DPS Kids — A World of Its Own</h2>
//           <p>"A Kid’s Heaven"</p>

//           <div style={styles.grid}>
//             {["Independence", "Motor Skills", "Communication", "Social Awareness"].map((item, i) => (
//               <div key={i} style={styles.box}>{item}</div>
//             ))}
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// const styles = {
//   hero: {
//     position: "relative",
//     height: "350px",
//   },
//   heroImg: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   overlay: {
//     position: "absolute",
//     inset: 0,
//     background: "rgba(0,0,0,0.6)",
//   },
//   heroContent: {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     color: "#fff",
//     fontFamily: 'sans-serif',
     
//   },

//   container: {
//     maxWidth: "1200px",
//     margin: "auto",
//     padding: "50px 20px",
//   },

//   row: {
//     display: "flex",
//     gap: "40px",
    
//     marginBottom: "60px",
//     flexWrap: "wrap",
//   },

//   image: {
//     width: "100%",
//     maxWidth: "500px",
//     borderRadius: "20px",
//     objectFit: "cover",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//   },

//   card: {
//     flex: 1,
//     background: "#fff",
//     padding: "30px",
//     borderRadius: "20px",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
//     lineHeight: "1.7",
//     transition: "0.3s",
//   },

//   footer: {
//     background: "rgb(0,111,47)",
//     color: "#fff",
//     fontFamily: 'sans-serif',
//     padding: "50px 20px",
//     borderRadius: "20px",
//   },

//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))",
//     gap: "20px",
//     marginTop: "30px",
//   },

//   box: {
//     background: "rgba(255,255,255,0.2)",
//     padding: "15px",
//     borderRadius: "10px",
//   },
// };

// export default MissionVision;

// import React, { useEffect } from "react";

// const MissionVision = () => {
//   const primaryColor = "rgb(0, 111, 47)";

//   useEffect(() => {
//     const elements = document.querySelectorAll(".fade-up");

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.style.opacity = 1;
//             entry.target.style.transform = "translateY(0)";
//           }
//         });
//       },
//       { threshold: 0.2 }
//     );

//     elements.forEach((el) => observer.observe(el));
//   }, []);

//   return (
//     <div style={{ background: "#f8fafc", fontFamily: "sans-serif" }}>
      
//       {/* HERO (BLACK OVERLAY REMOVED) */}
//       <div style={styles.hero}>
//         <img
//           src="https://dpsladwa.com/Dpsschool_Data/uploads/images/1776677437_69e5f23d6b57b.jpg"
//           style={styles.heroImg}
//         />

//         <div style={styles.heroContent} className="fade-up">
//           <h1 style={styles.heroTitle}>Mission & Vision</h1>
//           <p style={styles.heroText}>
//             Inspired to Educate. Committed to Enlighten.
//           </p>
//         </div>
//       </div>

//       <div style={styles.container}>

//         {/* MISSION */}
//         <div style={styles.row} className="fade-up">
//           <img
//             src="https://dpsladwa.com/Dpsschool_Data/uploads/images/1776677418_69e5f22a16a25.jpg"
//             style={styles.image}
//           />

//           <div style={styles.card}>
//             <h2 style={{ color: primaryColor }}>Our Mission</h2>
//             <p><b>"Service Before Self"</b></p>
//             <p>
//               Our mission is to create a joyful learning environment guided by:
//               <b> Inspire. Educate. Enlighten.</b>
//             </p>

//             <ul style={styles.list}>
//               <li>✓ Every child is unique</li>
//               <li>✓ Quality education for all</li>
//               <li>✓ Real world learning</li>
//             </ul>
//           </div>
//         </div>

//         {/* VISION */}
//         <div style={{ ...styles.row, flexDirection: "row-reverse" }} className="fade-up">
//           <img
//             src="https://dpsladwa.com/Dpsschool_Data/uploads/images/1776677437_69e5f23d6b57b.jpg"
//             style={styles.image}
//           />

//           <div style={styles.card}>
//             <h2 style={{ color: "#b8860b" }}>Our Vision</h2>
//             <p>
//               We aim to create a meaningful space where students grow with purpose.
//             </p>

//             <ul style={styles.list}>
//               <li>★ Holistic development</li>
//               <li>★ Celebrate achievements</li>
//               <li>★ Independent learners</li>
//               <li>★ Trust-based environment</li>
//             </ul>
//           </div>
//         </div>

//         {/* FOOTER */}
//         <div style={styles.footer} className="fade-up">
//           <h2>DPS Kids — A World of Its Own</h2>
//           <p>"A Kid’s Heaven"</p>

//           <div style={styles.grid}>
//             {["Independence", "Motor Skills", "Communication", "Social Awareness"].map((item, i) => (
//               <div key={i} style={styles.box}>{item}</div>
//             ))}
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// const styles = {
//   hero: {
//     position: "relative",
//     height: "350px",
//   },

//   heroImg: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },

//   heroContent: {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%) translateY(40px)",
//     color: "#fff",
//     textAlign: "center",
//     opacity: 0,
//     transition: "all 0.8s ease",
//   },

//   heroTitle: {
//     fontSize: "40px",
//     fontWeight: "700",
//   },

//   heroText: {
//     fontSize: "16px",
//     marginTop: "10px",
//   },

//   container: {
//     maxWidth: "1200px",
//     margin: "auto",
//     padding: "50px 20px",
//   },

//   row: {
//     display: "flex",
//     gap: "40px",
//     marginBottom: "60px",
//     flexWrap: "wrap",
//     opacity: 0,
//     transform: "translateY(40px)",
//     transition: "all 0.8s ease",
//   },

//   image: {
//     width: "100%",
//     maxWidth: "500px",
//     borderRadius: "20px",
//     objectFit: "cover",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//   },

//   card: {
//     flex: 1,
//     background: "#fff",
//     padding: "30px",
//     borderRadius: "20px",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
//     lineHeight: "1.7",
//   },

//   list: {
//     paddingLeft: "20px",
//   },

//   footer: {
//     background: "rgb(0,111,47)",
//     color: "#fff",
//     padding: "50px 20px",
//     borderRadius: "20px",
//     textAlign: "center",
//     opacity: 0,
//     transform: "translateY(40px)",
//     transition: "all 0.8s ease",
//   },

//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))",
//     gap: "20px",
//     marginTop: "30px",
//   },

//   box: {
//     background: "rgba(255,255,255,0.2)",
//     padding: "15px",
//     borderRadius: "10px",
//     transition: "0.3s",
//   },
// };

// export default MissionVision;

import React, { useState } from "react";

const AnimatedCard = ({ title, color, content, list }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      style={{
        ...styles.card,
        transform: hover ? "translateY(-8px)" : "translateY(0)",
        boxShadow: hover
          ? "0 20px 40px rgba(0,0,0,0.1)"
          : "0 10px 30px rgba(0,0,0,0.05)",
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <h2 style={{ ...styles.text, color }}>{title}</h2>

      {content.map((item, i) => (
        <p
          key={i}
          style={{
            ...styles.text,
            transform: hover ? "translateX(0)" : "translateX(-20px)",
            opacity: hover ? 1 : 0.6,
            transitionDelay: `${i * 0.1}s`,
          }}
        >
          {item}
        </p>
      ))}

      <ul style={styles.list}>
        {list.map((item, i) => (
          <li
            key={i}
            style={{
              ...styles.text,
              transform: hover ? "translateX(0)" : "translateX(-20px)",
              opacity: hover ? 1 : 0.6,
              transitionDelay: `${i * 0.15}s`,
            }}
          >
            ✓ {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

const MissionVision = () => {
  return (
    <div style={{ background: "#f8fafc", fontFamily: "sans-serif" }}>
      
      {/* HERO */}
       
      <div style={styles.hero}>
        <img
          src="https://dpsladwa.com/Dpsschool_Data/uploads/images/1776677437_69e5f23d6b57b.jpg"
          style={styles.heroImg}
        />
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>Mission & Vision</h1>
          <p style={styles.heroText}>
            Inspired to Educate. Committed to Enlighten.
          </p>
     
        </div>
             <div style={styles.heroOverlay} />
      </div>

      <div style={styles.container}>

        {/* MISSION */}
        <div style={styles.row}>
          <img
             src="https://dpsladwa.com/Dpsschool_Data/uploads/images/1777116256_69eca4604994b.jpeg"
            style={styles.image}
          />

          <AnimatedCard
            title="Our Mission"
            color="rgb(0,111,47)"
            content={[
              '"Service Before Self"',
              "Our mission is to create a joyful learning environment guided by:",
              "Inspire. Educate. Enlighten.",
            ]}
            list={[
              "Every child is unique",
              "Quality education for all",
              "Real world learning",
            ]}
          />
        </div>

        {/* VISION */}
        <div style={{ ...styles.row, flexDirection: "row-reverse" }}>
          <img
          
             src="https://dpsladwa.com/Dpsschool_Data/uploads/images/1777116588_69eca5ac18f91.jpeg"
            style={styles.image}
          />

          <AnimatedCard
            title="Our Vision"
            color="#b8860b"
            content={[
              "We aim to create a meaningful space where students grow with purpose.",
            ]}
            list={[
              "Holistic development",
              "Celebrate achievements",
              "Independent learners",
              "Trust-based environment",
            ]}
          />
        </div>

      </div>
    </div>
  );
};

/* ================= STYLES ================= */

// const styles = {
//   hero: {
//     position: "relative",
//     height: "350px",
//     marginTop:150
//   },
//   heroOverlay: {
//     position: "absolute",
//     inset: 0,
//     background: "rgba(0,0,0,0.45)",
//   },
//   heroImg: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },

//   heroContent: {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     color: "#fff",
//     textAlign: "center",
//   },

//   heroTitle: {
//     fontSize: "25px",
//     fontWeight: "700",
//   },

//   heroText: {
//     fontSize: "16px",
//   },

//   container: {
//     maxWidth: "1200px",
//     margin: "auto",
//     padding: "50px 20px",
//   },

//   row: {
//     display: "flex",
//     gap: "40px",
//     marginBottom: "60px",
//     flexWrap: "wrap",
//   },

//   image: {
//     width: "100%",
//     maxWidth: "500px",
//     borderRadius: "20px",
//     objectFit: "cover",
//   },

//   card: {
//     flex: 1,
//     background: "#fff",
//     padding: "30px",
//     borderRadius: "20px",
//     transition: "0.3s",
//   },

//   text: {
//     transition: "all 0.4s ease",
//     marginBottom: "10px",
//   },

//   list: {
//     listStyle: "none", // 🔥 DOT REMOVE
//     padding: 0,
//     marginTop: "10px",
//   },
// };

// 

const styles = {
  hero: {
    position: "relative",
    height: "clamp(220px, 45vh, 420px)", // 🔥 responsive height
    marginTop: "clamp(80px, 10vw, 150px)",
  },

  heroOverlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
  },

  heroImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },

  heroContent: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "#fff",
    textAlign: "center",
    width: "90%", // ✅ mobile safe
  },

  heroTitle: {
    fontSize: "clamp(20px, 5vw, 36px)", // 🔥 responsive text
    fontWeight: "700",
  },

  heroText: {
    fontSize: "clamp(14px, 2.5vw, 18px)",
  },

  container: {
    maxWidth: "1100px",
    margin: "auto",
    padding: "clamp(30px, 6vw, 60px) 16px", // 🔥 dynamic spacing
  },

  row: {
    display: "grid",

    // 🔥 FLEX → GRID (better responsive)
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",

    gap: "clamp(20px, 4vw, 40px)",
    marginBottom: "clamp(30px, 6vw, 60px)",
    alignItems: "center",
  },

  image: {
    width: "100%",
    height: "100%",
    maxHeight: "320px", // ✅ control height
    borderRadius: "16px",
    objectFit: "cover",
  },

  card: {
    background: "#fff",
    padding: "clamp(18px, 3vw, 30px)",
    borderRadius: "16px",
    transition: "0.3s",
    boxShadow: "0 10px 24px rgba(0,0,0,0.06)", // 🔥 premium feel
  },

  text: {
    transition: "all 0.4s ease",
    marginBottom: "10px",
    fontSize: "clamp(14px, 2.5vw, 16px)",
    lineHeight: "1.7",
    color: "#4b5563",
  },

  list: {
    listStyle: "none",
    padding: 0,
    marginTop: "10px",
    display: "grid",
    gap: "8px",
    fontSize: "clamp(14px, 2.5vw, 15px)",
  },
};
export default MissionVision;